//导入模块
import Vue from 'vue';
import VueRouter from 'vue-router';
import index from '../components/index.vue';
import ComplaintQuery from "../components/ComplaintQuery.vue";

//注册路由组件
Vue.use(VueRouter);
//编写路由规则
const routes = [
  {
    path:"/",
    name:'index',
    component:index
  },
  {
    path:"/complaintQuery",
    name:'ComplaintQuery',
    component:ComplaintQuery
  },
]
//创建路由
const router = new VueRouter({
  mode:'history',
  routes
})
//导出
export default router;





// WEBPACK FOOTER //
// ./src/router/index.js